var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('v-btn',{staticClass:"button",attrs:{"fab":"","small":"","color":_vm.color},on:{"click":function($event){return _vm.click()}}},[_c('img',{attrs:{"src":_vm.roleIcon(_vm.role),"width":"20"}})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }